import { Zap, Clock, Users, Wrench, MapPin, ShieldCheck } from "lucide-react";

const DIFFS = [
  { icon: Zap, title: "Atendimento Imediato", desc: "Resposta rapida para sua emergencia" },
  { icon: Clock, title: "Funcionamento 24h", desc: "Disponivel dia e noite, todos os dias" },
  { icon: Users, title: "Equipe Experiente", desc: "Profissionais treinados e qualificados" },
  { icon: Wrench, title: "Equipamentos Modernos", desc: "Frota atualizada para qualquer veiculo" },
  { icon: MapPin, title: "Toda a Regiao", desc: "Atendimento em Navirai e cidades proximas" },
  { icon: ShieldCheck, title: "Total Seguranca", desc: "Seu veiculo tratado com maximo cuidado" },
];

export default function Differentials() {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="py-24 sm:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-[#FFD700] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest mb-6">
            Diferenciais
          </div>
          <h2
            data-testid="differentials-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight uppercase mb-4"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Por que escolher a{" "}
            <span className="text-[#FFD700]">Huck Guincho</span>?
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {DIFFS.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              data-testid="differential-card"
              className="diff-card flex items-start gap-4 bg-black border border-[#27272A] p-6 rounded-sm"
            >
              <div className="bg-[#FFD700] w-12 h-12 flex items-center justify-center rounded-sm flex-shrink-0">
                <Icon className="w-6 h-6 text-black" />
              </div>
              <div>
                <h3
                  className="text-lg font-bold uppercase tracking-tight text-white mb-1"
                  style={{ fontFamily: "'Oswald', sans-serif" }}
                >
                  {title}
                </h3>
                <p className="text-sm text-gray-400">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
